<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">It’s such a simple thing to make love. <br/>It’s like being thirsty and drinking. <br/>Nothing could be simpler than being thirsty and drinking; <br/>quenching one’s thirst, feeling satisfaction at having done so; <br/>no longer feeling thirst. Utterly simple. <br/><span class="smallcaps">—LEONARDO SCIASCIA</span>, <em class="italic">One Way or Another</em> <br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// threeimperfect_00001.vue?fd6a4404